/**
 * this pipe use to conver number of person in account
 * if linked account has 3 linked account then show '3 People'
 * if has no linked account return nobody
 * if only 1 linked account return '1 Person'
 */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pluralizer'
})
export class PluralizerPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    let text = 'Nobody';
    if (value.length === 1) {
      text = `${value.length} Person`;
    } else if ( value.length > 1) {
      text = `${value.length} People`;
    }
    return text;
  }

}
